const EmployeesTableColumns = [
    { id: 'code', labelAr: 'الكود', labelEn: 'Code', width: 80 },
    { id: 'full_name', labelAr: 'الاسم الكامل', labelEn: 'Full Name' },
    { id: 'gender', labelAr: 'الجنس', labelEn: 'Gender', width: 80 },
    { id: 'department_name', labelAr: 'القسم', labelEn: 'Dept', width: 140 },
    { id: 'job_title_name', labelAr: 'المسمى الوظيفي', labelEn: 'Job Title', width: 140 },
    { id: 'phone', labelAr: 'الهاتف', labelEn: 'Phone', width: 120 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 90 },
];

export default EmployeesTableColumns;
